import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-logged-out',
    templateUrl: './logged-out.component.html',
    imports: [RouterModule, MatButtonModule],
})
export class LoggedOutComponent {}
